// extracted by mini-css-extract-plugin
export default {"container":"_3xe0npWisoi005KBSf6uZx","slider":"_3cjZ74zQagTDso0F6sXZQp"};